import './Code.css';
export var codeCSS = '_1v51izp2-3-15-1';